// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__AhQyS","rootSuccess":"CompleteLink_rootSuccess__39ZjT","rootFailure":"CompleteLink_rootFailure__1w8hO","isDisabled":"CompleteLink_isDisabled__3njBg"};